<script>

	import format from 'string-format'
	import {Line, mixins} from 'vue-chartjs'
	import zoomPlugin from 'chartjs-plugin-zoom'
	// import selectPlugin from 'chartjs-plugin-select'
	import {Plate} from '../../../models'
	import {
		LOAD_WELL_PROBE_DATA, PURGE_WELL_DATA
	} from '../../../store/modules/plate'
	import {mapActions} from 'vuex'

	const {reactiveProp} = mixins

	export default {
		name: "plate-probe-chart",
		componentName: "PlateProbeChart",
		extends: Line,

		data: function () {
			return {
				component_name: 'PlateProbeChart',

				loading_promise: null,

				// store_mutation_unsubscriber: null,

				// рисуемые лунки, dict[well_num, dataset_i]
				// чтобы сопоставить well_num и индекс в массиве датасетов чарта
				wells: {},

				// для проверки повторной загрузки данных
				loaded_wells: {},

				// диапазон значений для оси y
				probe_min: 0,
				probe_max: 0,

				data: {
					labels: ['cyc1', 'cyc2', 'cyc3'],

					// two dimensional array by row (wells) x col (probes)
					datasets: [
						{
							tension: 0,
							label: 'line1',
							borderColor: 'red',
							borderWidth: 1,
							fill: false,
							data: [1.0, 0.0, 0.3],
						},
						{
							label: 'line2',
							borderColor: 'blue',
							borderWidth: 1,
							fill: false,
							data: [0.0, 0.2, 0.7],
						}]
				},

				options: {
					respoinsive: true,
					animation: {duration: 0,},

					hover: {
						axis: 'xy',
					},

					events: ['mousedown', 'mouseup', 'mousemove', 'mousewheel',],
					maintainAspectRatio: false,

					legend: {display: false,},
					tooltips: {display: false,},

					scales: {
						yAxes: [{
							type: 'linear',
							position: 'left',
							ticks: {},
						},],
					},

					plugins: {
						// select: {
						// 	events: ['mousedown', 'mouseup',],
						// },

						zoom: {
							zoom: {
								enabled: true,
								drag: false,

								mode: 'y',

								rangeMin: {},
								rangeMax: {},
							},
							pan: {
								enabled: true,
								mode: 'y',
							},
						},
					}
				},
			}
		},

		props: {
			disabled: {type: Boolean, default: false,},
			plate: {type: Plate, default: () => Plate.empty_plate,},
			show_background: {type: Boolean, default: false,},
			corr_background: {type: Boolean, default: false,},
			selected_wells: {type: Array, default: () => [],},
			hovered_well: {type: Number, default: -1,},
			selected_probes: {type: Array, defult: () => [],},
		},

		watch: {
			plate: function (new_value, old_value) {
				console.debug(format("PlateProbeChart.watch.plate() plate_id={0}", this.plate.id))
				this.update_chart()
			},

			show_background: function (new_value, old_value) {
				console.debug(format("PlateProbeChart.watch.show_background( {0} ) ", this.show_background))
				this.update_chart()
			},

			corr_background: function (new_value, old_value) {
				console.debug(format("PlateProbeChart.watch.corr_background( {0} ) ", this.corr_background))
				this.update_chart()
			},

			selected_wells: function (new_wells, old_wells) {
				console.debug(format(
					"PlateProbeChart.watch.selected_wells( {0} ) plate_id={1}",
					JSON.stringify(this.selected_wells), this.plate.id))

				this.update_chart()
			},

			hovered_well: function (new_value, old_value) {
				if (!this.disabled) {
					const me = this
					this.loading_promise
						.then(function () {
							let updated = false // Flag to refresh chart after dataset change

							if (me.selected_wells.indexOf(old_value) !== -1) {
								// console.debug(format("PlateProbeChart.watch.hovered_well( old: {0} ) begin", old_value))
								me.update_well_chart(old_value)
								updated = true
							}

							if (me.selected_wells.indexOf(new_value) !== -1) {
								// console.debug(format("PlateProbeChart.watch.hovered_well( new: {0} ) begin", new_value))
								me.update_well_chart(new_value)
								updated = true
							}

							if (updated) {
								me.refresh()
								// console.debug(format("PlateProbeChart.watch.hovered_well( {0} ) end", this.hovered_well))
							}
						})
				}
			},

			selected_probes: function (new_probes, old_probes) {
				console.debug(format(
					"PlateProbeChart.watch.selected_probes( {0} ) ",
					this.selected_probes))

				this.update_chart()
			},

			disabled: function (new_value, old_value) {
				console.debug(format("PlateProbeChart.watch.disabled( {0} )", this.disabled))

				// const selected_wells = this.selected_wells
				// const me = this
				// setTimeout(function () {
				// 	me.selected_wells = selected_wells
				// }, 100)
				const me = this
				this.loading_promise
					.then(function () {
						me.update_chart()
					})
			},
		},

		computed: {
			chart: function () {
				return this.$data._chart
			}
		},

		created() {
			console.warn(format("PlateProbeChart.create()"))

			const me = this
			this.store_mutation_unsubscriber = this.$store.subscribe(
				this.store_mutation_handler)

			this.loading_promise = Promise.resolve()
		},
		destroyed() {
			this.store_mutation_unsubscriber()
		},

		mounted() {
			// this.addPlugin(selectPlugin)
			this.addPlugin(zoomPlugin)
		},

		methods: {
			...mapActions({
				progress_begin: 'progress/begin',
				progress_end: 'progress/end',

				message_add: 'message/add'
			}),

			store_mutation_handler: function (mutation, state) {
				console.debug(format(
					"PlateProbeChart.store_mutation_handler( type: '{0}' )",
					mutation.type))

				try {
					if (mutation.type === 'plate/' + LOAD_WELL_PROBE_DATA) {
						const well_num = mutation.payload.well.well_num

						// to check well probe_data double loading
						if (!(well_num in this.loaded_wells)) {
							this.loaded_wells[well_num] = true
						} else {
							console.error(format("Double loaded #{0}", well_num))
						}
						this.load_well_probe_data(well_num)

					} else if (mutation.type === 'plate/' + PURGE_WELL_DATA) {
						// to check well probe_data double loading
						this.loaded_wells = {}
					}
				} catch (error) {
					// нельзя выбрасывать исключения в обработчиках мутаций,
					// иначе в action случится повторная установка данных на пустые
					console.error("Catching any error on mutation handling.")
					console.error(error)
					// console.trace()
				}
			},

			load_well_probe_data: function (well_num) {
				console.debug(format(
					"PlateProbeChart.load_well_probe_data( #{well_num} )",
					{well_num: well_num}))

				// событие обновления прилетает для лунки,
				// а значит надо обновить графики всех зондов лунки
				this.update_well_chart(well_num)

				this.refresh()
			},

			get_well_probe_data: function (well, probe) {

				let probe_curve = probe.id in well.probe_data && well.probe_data[probe.id].curve
					? Array.from(well.probe_data[probe.id].curve) // copying is necessary such as we change values
					: []

				if (this.corr_background) {
					// возможна ситуация при которой кривая зонда есть,
					// а фон для нее еще не расчитан, в этом случае
					// TODO: пока непонятно как поступать
					const bg_curve = probe.id in well.probe_data && well.probe_data[probe.id].bg_curve
						? well.probe_data[probe.id].bg_curve
						: []

					const point_count = Math.min(probe_curve.length, bg_curve.length)
					for (let point_i = 0; point_i < point_count; point_i++) {
						probe_curve[point_i] = probe_curve[point_i] - bg_curve[point_i]
					}
				}

				let res = {
					tension: 0,
					fill: false,
					borderColor: probe.color,
					borderWidth: 1,
					pointRadius: 0,
					pointHoverRadius: 0,
					data: probe_curve,
				}

				const lineStyle = well.treat != null ? well.treat.lineStyle : null
				if (lineStyle != null) {
					for (const key in lineStyle) {
						res[key] = lineStyle[key]
					}
				}

				if (probe.id === -1000) {
					res.borderWidth = 1
					res.borderDash = [2, 1]
				}

				if (well.well_num === this.hovered_well) {
					res.borderWidth = 3
				}

				return res
			},

			get_well_probe_bg_data: function (well, probe) {
				const probe_bg_data = probe.id in well.probe_data
					? well.probe_data[probe.id].bg_curve
					: []

				let res = {
					tension: 0,
					fill: false,
					borderColor: probe.color_bg,
					borderWidth: 2.5,
					pointRadius: 0,
					pointHoverRadius: 0,
					data: probe_bg_data,
				}

				return res
			},

			/**
			 * Update curves of probes of well
			 */
			update_well_chart: function (well_num) {
				const well = this.plate.wells[well_num]
				const well_base = this.wells[well_num]

				// в selected_probes массив с probe.id
				// в this.plate.probes словарь по ключу probe.id
				for (let sp_i = 0; sp_i < this.selected_probes.length; sp_i++) {
					const probe = this.plate.probes[this.selected_probes[sp_i]]

					this.data.datasets[well_base + sp_i] =
						well.probe_data != null
							? this.get_well_probe_data(well, probe)
							: {}
				}

				const well_bg_base = well_base + this.selected_probes.length

				for (let sp_i = 0; sp_i < this.selected_probes.length; sp_i++) {
					const probe = this.plate.probes[this.selected_probes[sp_i]]

					this.data.datasets[well_bg_base + sp_i] =
						well.probe_data != null && this.show_background && !this.corr_background
							? this.get_well_probe_bg_data(well, probe)
							: {}
				}
			},

			update_chart: function () {
				if (!this.disabled) {
					console.debug("PlateProbeChart.update_chart()")

					const me = this
					// подождем окончания предыдущего запроса данных
					Promise.all([
						this.loading_promise,
						new Promise(function (resolve) {
							let loading_wells = []
							for (let sw_i = 0; sw_i < me.selected_wells.length; sw_i++) {
								const well_num = me.selected_wells[sw_i]
								if (me.plate.wells[well_num].probe_data === null) {
									loading_wells.push(well_num)
								}
							}
							resolve(loading_wells)
						})
					])
						.then(function ([, loading_wells]) {
							// заполним список лунок, для которых нужно загрузить данные probe_data

							// if (loading_wells.length > 1) {
							// 	me.progress_begin({message: "Loading wells' probe data..."})
							// }

							me.loading_promise = Promise.all(
								// TODO: отправлять один запрос на обновление всех лунок
								loading_wells.map(function (well_num) {
									return me.plate.wells[well_num].load_probe_data(me.$store.dispatch)
								}))
								.then(function (response_list) {
									// данные всех выделенных лунок уже загружены
									console.debug("PlateProbeChart.update_chart() .then")
									me.update_chart_datasets()
								})
								.catch(function (error) {
									me.message_add(error)
								})
								.finally(function () {
									// if (loading_wells.length > 1) {
									// 	me.progress_end()
									// }
								})

							return me.loading_promise
						})
				}
			},

			update_chart_datasets: function () {
				console.debug("PlateProbeChart.update_chart_datasets()")
				/**
				 * Here we build structure of chartjs dataset.
				 * Because it is linear but we have [wells х probes] (and background),
				 * so we will use index (address) arithmetic.
				 */

				this.data.labels = Array.from(
					[...Array(this.plate.points.length).keys()],
					(c) => c + 1)

				// reset chart dataset
				this.wells = {}
				this.loaded_wells = {}

				// *2 - for probes' background curves
				this.data.datasets = new Array(
					this.selected_wells.length * this.selected_probes.length * 2)

				// Fill in chart dataset items with {}
				for (let sw_i = 0; sw_i < this.selected_wells.length; sw_i++) {
					const well_num = this.selected_wells[sw_i]
					const well_base = this.wells[well_num] = sw_i * this.selected_probes.length * 2

					for (let sp_i = 0; sp_i < this.selected_probes.length * 2; sp_i++) {
						this.data.datasets[well_base + sp_i] = {}
					}
				} // sw_i - wells

				if (!this.disabled) {
					for (let sw_i = 0; sw_i < this.selected_wells.length; sw_i++) {
						const well_num = this.selected_wells[sw_i]
						const well = this.plate.wells[well_num]

						if (well.probe_data != null) {
							this.update_well_chart(well_num)
						}
					}  // sw_i - wells
				} // disabled

				// this.data.datasets = ds
				// this.options.plugins.zoom.zoom.rangeMin.y = this.plate.spectra_min
				// this.options.plugins.zoom.zoom.rangeMax.y = this.plate.spectra_max
				this.refresh()
			},

			refresh: function () {
				const me = this

				if (!this.disabled) {
					if (this.$refs.canvas) {

						if (this.$data._chart !== null) {
							// сохраним окно координат при перерисовке
							const y_min = this.$data._chart.scales['y-axis-0'].min
							const y_max = this.$data._chart.scales['y-axis-0'].max
							if (y_min !== 0 && y_max !== 1) {
								this.options.scales.yAxes[0].ticks.min = y_min
								this.options.scales.yAxes[0].ticks.max = y_max
							}
						}
						this.renderChart(this.data, this.options)

					} else {
						console.warn(format(
							"PlateProbeChart.refresh( this='{0}', this.$refs.canvas={1} )",
							me.constructor.name,
							this.$refs.canvas))
					}
				}
			},

			reset: function () {
				try {
					this.$data._chart.resetZoom()
				} catch (error) {
					this.message_add(error)
				}
			},

			// -- Handle controls' events --
			charSelectPlugin_selectCallback: function (startPoint, endPoint) {
				console.debug('PlateProbeChart.selectCallback()')

				this.options.scales.yAxes[0].ticks.min = Math.min(startPoint.y, endPoint.y)
				this.options.scales.yAxes[0].ticks.max = Math.max(startPoint.y, endPoint.y)

				return true
			}
		},
	}
</script>

<style scoped>

</style>